import scrim from "./Scrim.svelte";
import spacer from "./Spacer.svelte";

export const Scrim = scrim;
export const Spacer = spacer;

export default {
  Scrim,
  Spacer
};
